import React from 'react';
const FormGroup = React.createClass({
	render(){

		if(this.props.label) {
			return (
				<label className="ma-form-group">
					<div className="ma-form-label">
						{this.props.label}
					</div>
					<div className="ma-form-input">
						{this.props.children}
					</div>
				</label>
			);
		} else {
			return (
				<div className="ma-form-group">
					<div className="ma-form-input">
						{this.props.children}
					</div>
				</div>
			);
		}


	}
});
export default FormGroup;


/** WEBPACK FOOTER **
 ** ./src/components/FormGroup/FormGroup.js
 **/